module.exports = __webpack_public_path__ + "static/casino-a80f605e79b3fd84e2c5e18a582eb710.jpg";